// "All Projects" mode. Mirrors the Android sentinel selectedProjectId == -1:
// a synthetic project that, when selected, shows tasks across every project.
export const ALL_PROJECTS_ID = "-1";

export const ALL_PROJECTS = {
  id: ALL_PROJECTS_ID,
  projectName: "All Projects",
};

/** True for the All Projects sentinel, whether it arrives as "-1" or -1. */
export const isAllProjects = (id) => String(id) === ALL_PROJECTS_ID;
